export default "__VITE_ASSET__Dhpsj168__"